import React, { useState } from "react";
import ProfilePage from "./Profilepage";
import Sidebar from "../Sidebar";

function LeetCodeInputPage() {
  const [username, setUsername] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (e) => {
    setUsername(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="flex">
      <div className="hidden md:block">
        <Sidebar />
      </div>
    <div className="p-4 flex-1 min-h-screen text-black">
      {!submitted ? (
        <>
          <h2 className="text-xl bg-gradient-to-r from-violet-500 to-red-500 text-transparent bg-clip-text font-bold mb-4 text-center mt-16">Enter Your LeetCode Username</h2>
          <form onSubmit={handleSubmit} className="flex justify-center items-center mb-4">
            <input
              type="text"
              placeholder="LeetCode ID"
              value={username}
              onChange={handleInputChange}
              className="border p-2 mr-2 ronded justify-center"
            />
            <button
              type="submit"
              className="bg-blue-500 text-white p-2 rounded justify-center hover:bg-blue-700 transition duration-300"
            >
              Submit
            </button>
          </form>
        </>
      ) : (
        <ProfilePage name={username} />
      )}
    </div>
  </div>
  );
}

export default LeetCodeInputPage;
